import { FC } from 'react';
import { Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';
import { BimDataModelProgress } from 'Data/interfaces/BimViewer/IBimViewerPort';
import { Bar, Fill, HitArea } from './styles';

/**
 * Andamento do data model, ancorado pela toolbar acima e à esquerda dela. Uma barra só, uma etapa por vez
 * (download → árvore → propriedades), cada uma de 0 a 100; o nome da etapa fica
 * no tooltip, para não disputar espaço com a cena. No federado, `model` diz de
 * qual modelo é o andamento.
 */
export const DataModelProgress: FC<{ progress: BimDataModelProgress; model?: string }> = ({ progress, model }) => {
  const { t } = useTranslation('viewer');
  const percent = Math.max(0, Math.min(100, Math.round(progress.percent)));
  const step = t(`bim3dDataModel.${progress.phase}`, { percent });

  return (
    <Tooltip title={model ? <>{model}<br />{step}</> : step} placement="top">
      <HitArea role="progressbar" aria-valuenow={percent} aria-valuemin={0} aria-valuemax={100}>
        <Bar>
          <Fill $percent={percent} $phase={progress.phase} />
        </Bar>
      </HitArea>
    </Tooltip>
  );
};
